import { Megaphone, PanelsTopLeft, Shirt, Building2, ArrowUpRight } from "lucide-react";
import { FadeUp, SectionHead } from "../Reveal";
import { waLink } from "../../data/site";
import { track } from "../../lib/analytics";

const CATEGORIES = [
    {
        icon: Megaphone,
        title: "Identidade e divulgação",
        items: ["Cartões de visita", "Panfletos", "Adesivos", "Materiais promocionais"],
        message: "Olá! Preciso de materiais de identidade e divulgação (cartões, panfletos, adesivos). Vim pelo site da Imprima Aki.",
    },
    {
        icon: PanelsTopLeft,
        title: "Comunicação visual",
        items: ["Placas", "Banners", "Faixas", "Fachadas", "Comunicação interna"],
        message: "Olá! Preciso de comunicação visual (placas, banners, faixas ou fachada). Vim pelo site da Imprima Aki.",
    },
    {
        icon: Shirt,
        title: "Uniformização",
        items: ["Camisetas personalizadas", "Uniformes", "Serigrafia", "Sublimação"],
        message: "Olá! Preciso de camisetas personalizadas ou uniformes para minha equipe. Vim pelo site da Imprima Aki.",
    },
    {
        icon: Building2,
        title: "Presença e marca",
        items: ["Envelopamento automotivo", "Adesivação", "Materiais para pontos comerciais"],
        message: "Olá! Quero fortalecer a presença da minha marca (envelopamento, adesivação, ponto comercial). Vim pelo site da Imprima Aki.",
    },
];

export const Categories = () => (
    <section id="solucoes" data-testid="categories-section" className="bg-paper py-20 sm:py-28 lg:py-32">
        <div className="container-x">
            <SectionHead
                tag="01 — O que sua empresa precisa?"
                title="Tudo o que sua empresa precisa para aparecer profissionalmente."
                sub="Do impresso do dia a dia à sinalização completa do seu ponto: escolha o caminho e peça o orçamento em minutos."
            />
            <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {CATEGORIES.map((cat, i) => (
                    <FadeUp key={cat.title} delay={i * 0.08} className="h-full">
                        <div
                            data-testid={`category-card-${i}`}
                            className="group flex h-full flex-col rounded-2xl border border-[#E9E9E9] bg-white p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-brand/40 hover:shadow-[0_20px_50px_-20px_rgba(13,13,13,0.18)]"
                        >
                            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-ink text-white transition-colors duration-500 group-hover:bg-brand">
                                <cat.icon size={22} strokeWidth={1.8} />
                            </div>
                            <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-ink">{cat.title}</h3>
                            <ul className="mt-4 flex-1 space-y-2.5">
                                {cat.items.map((item) => (
                                    <li key={item} className="flex items-center gap-2.5 text-sm text-smoke">
                                        <span className="h-1 w-1 rounded-full bg-brand" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                            <a
                                href={waLink(cat.message)}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => track("whatsapp_click", { location: "category", category: cat.title })}
                                data-testid={`category-cta-${i}`}
                                className="mt-7 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-ink transition-colors group-hover:text-brand"
                            >
                                Solicitar orçamento
                                <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </a>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);
